import FormInputText from './../Partials/FormInputText';
import FormInputTextArea from './../Partials/FormInputTextArea';
import MetaColumn from './MetaColumn';
import GeneralForm from './../Forms/GeneralForm';

const FooterPageBuilder = {
    component: GeneralForm,
    options: {
        columns: {
            contents: [
                {
                    field: "title",
                    partial: {
                        handler: FormInputText,
                        props: {
                            initialValue: (formHandler) => {
                                return formHandler.getArrayInputValue("contents", "title");
                            },
                            required: true,
                            label: "عنوان"
                        }
                    }
                },
                {
                    field: "description",
                    partial: {
                        handler: FormInputTextArea,
                        props: {
                            initialValue: (formHandler) => {
                                return formHandler.getArrayInputValue("contents", "description");
                            },
                            required: true,
                            label: "توضیحات",
                            textSize: 7
                        }
                    }
                }
            ]
        }
    }
};

export default FooterPageBuilder;


// WEBPACK FOOTER //
// ./src/containers/Pages/Builders/FooterPageBuilder.js